import React from "react";

const Contact: React.FC = () => {
    const contacts = [
        {
            name: "Linktree",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M10.5 20.6h3v-4.3l1.6-1.6 3.4 5.9h3.4l-4.9-8.2 4.6-4.5h-3.8l-4.3 4.4V2.4h-3v6.8L6.9 5.8H3.1l4.7 4.6-4.9 4.5h3.7l4-4v9.7z" />
                </svg>
            ),
            url: "https://linktr.ee/gasstation33",
            color: "from-green-500 to-emerald-600",
        },
        {
            name: "Telegram Canal",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
                </svg>
            ),
            url: "https://t.me/+2tZU5BwyPRQ2YWQ8",
            color: "from-blue-500 to-blue-600",
        },
        {
            name: "PRISE DE COMMANDE",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z" />
                </svg>
            ),
            url: "https://t.me/gas_station33",
            color: "from-blue-400 to-blue-500",
        },
        {
            name: "Tato Menu / Video",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.477 2 2 6.03 2 11c0 2.83 1.3 5.36 3.44 7.03-.09.87-.4 2.03-1.19 3.35a.5.5 0 00.53.74c1.94-.4 3.36-1.1 4.24-1.63A11.6 11.6 0 0012 21c5.523 0 10-4.03 10-9s-4.477-9-10-9z" />
                </svg>
            ),
            url: "https://tato.im/joinchat/c1v8MWqHGtjWtJhfYS6twQ",
            color: "from-purple-600 to-purple-700",
        },
        {
            name: "Tato Principal",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2C6.477 2 2 6.03 2 11c0 2.83 1.3 5.36 3.44 7.03-.09.87-.4 2.03-1.19 3.35a.5.5 0 00.53.74c1.94-.4 3.36-1.1 4.24-1.63A11.6 11.6 0 0012 21c5.523 0 10-4.03 10-9s-4.477-9-10-9z" />
                </svg>
            ),
            url: "https://tato.im/joinchat/k1PgwDapHb3MTo_ROtfJGA",
            color: "from-purple-500 to-purple-600",
        },
        {
            name: "Instagram",
            icon: (
                <svg
                    className="w-8 h-8"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
            ),
            url: "https://www.instagram.com/gas.station33?igsi=cmdmZDk5a3RqMDd2",
            color: "from-purple-600 via-pink-500 to-orange-400",
        },
    ];

    return (
        <div className="min-h-screen py-20 px-4 relative">
            {/* Background image */}
            <div className="fixed inset-0 overflow-hidden">
                <div style={{
                    position: "absolute", inset: 0,
                    backgroundImage: "url('/bg.png')",
                    backgroundSize: "cover", backgroundPosition: "center",
                }}></div>
            </div>
            {/* Background overlay with opacity */}
            <div className="fixed inset-0 bg-primary-dark/85"></div>

            <div className="max-w-4xl mx-auto relative z-10">
                {/* Header */}
                <div className="text-center mb-16">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                        Contactez-nous
                    </h1>
                    <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                        Choisissez votre methode de communication preferee. Nous
                        sommes disponibles 24/7.
                    </p>
                </div>

                {/* Contact Buttons */}
                <div className="flex flex-col items-center space-y-6">
                    {contacts.map((contact) => (
                        <a
                            key={contact.name}
                            href={contact.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`w-full max-w-md card p-6 flex items-center justify-center space-x-4
                bg-gradient-to-r ${contact.color} hover:scale-105 transition-all duration-300
                border-none shadow-lg hover:shadow-xl`}
                        >
                            <span className="text-white">{contact.icon}</span>
                            <span className="text-white text-xl font-semibold">
                                {contact.name}
                            </span>
                        </a>
                    ))}
                </div>

                {/* Info Section */}
                <div className="mt-16 text-center">
                    <div className="card p-8 max-w-2xl mx-auto">
                        <h2 className="text-2xl font-semibold text-white mb-4">
                            Informations
                        </h2>
                        <ul className="text-gray-300 space-y-3 text-left">
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>Reponse garantie sous 24h maximum</span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>
                                    Communication chiffree de bout en bout
                                </span>
                            </li>
                            <li className="flex items-start space-x-3">
                                <svg
                                    className="w-5 h-5 text-accent mt-0.5 flex-shrink-0"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span>Discretion absolue assuree</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
